import { KeyboardEvent } from 'react';

// These fields count whole hours, minutes and days, so a decimal point or an
// exponent is never a value the user meant to enter.
const REJECTED_KEYS = ['.', ',', 'e', 'E', '+', '-'];

export const blockNonInteger = (event: KeyboardEvent<HTMLInputElement>): void => {
    if (REJECTED_KEYS.includes(event.key)) event.preventDefault();
};

/**
 * Parses what the user typed into a number the flow can always render.
 *
 * An empty field parses to NaN, and letting that reach the canvas is what put
 * the node tree into an unrenderable state, so it falls back to the minimum.
 */
export const clampInt = (raw: string, { min, max }: { min: number; max: number }): number => {
    const digits = raw.replace(/[^\d]/g, '');
    if (digits === '') return min;

    const parsed = parseInt(digits, 10);
    if (!Number.isFinite(parsed)) return min;

    return Math.min(Math.max(parsed, min), max);
};
